/**
 * Meliusly How It Works page behavior — product selector <-> detail guide
 * switching, desktop tab bar + mobile accordion for the tabbed feature
 * content, Compare button smooth-scroll, the comparison table's scroll
 * arrows + mobile position indicator, and the reviews carousel.
 */
(function () {
  var MINUS_ICON = '<svg class="h-[20px] w-[20px] text-[#0268A0]" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M5 12h14"></path></svg>';
  var PLUS_ICON = '<svg class="h-[20px] w-[20px] text-[#0268A0]" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>';

  // --- Product selector <-> detail guide switching ---
  var selectorButtons = Array.prototype.slice.call(document.querySelectorAll('[data-mel-hiw-select]'));
  var guides = Array.prototype.slice.call(document.querySelectorAll('[data-mel-hiw-guide]'));

  function setActiveGuide(index) {
    selectorButtons.forEach(function (btn) {
      var active = btn.getAttribute('data-mel-hiw-select') === String(index);
      var label = btn.querySelector('[data-mel-hiw-select-label]');
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.classList.toggle('border-[#0268A0]', active);
      btn.classList.toggle('bg-[#F3FAFE]', active);
      btn.classList.toggle('border-[rgba(34,34,34,0.1)]', !active);
      btn.classList.toggle('bg-white', !active);
      btn.classList.toggle('hover:border-[rgba(2,104,160,0.3)]', !active);
      if (label) {
        label.classList.toggle('text-[#0268A0]', active);
        label.classList.toggle('text-[#161F2B]', !active);
      }
    });
    guides.forEach(function (guide) {
      guide.hidden = guide.getAttribute('data-mel-hiw-guide') !== String(index);
    });
  }

  selectorButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setActiveGuide(btn.getAttribute('data-mel-hiw-select'));
    });
  });

  // --- Detail desktop tab bar ---
  var tabButtons = Array.prototype.slice.call(document.querySelectorAll('[data-mel-hiw-tab]'));

  function setActiveTab(group, tabKey) {
    tabButtons.forEach(function (btn) {
      if (btn.getAttribute('data-mel-hiw-tab-group') !== group) return;
      var active = btn.getAttribute('data-mel-hiw-tab') === tabKey;
      var underline = btn.querySelector('[data-mel-hiw-tab-underline]');
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
      btn.classList.toggle('text-[#0268A0]', active);
      btn.classList.toggle('text-[#161F2B]/70', !active);
      if (underline) underline.classList.toggle('hidden', !active);
    });
    Array.prototype.slice.call(document.querySelectorAll('[data-mel-hiw-panel][data-mel-hiw-tab-group="' + group + '"]')).forEach(function (panel) {
      var active = panel.getAttribute('data-mel-hiw-panel') === tabKey;
      panel.classList.toggle('hidden', !active);
      panel.classList.toggle('flex', active);
    });
  }

  tabButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setActiveTab(btn.getAttribute('data-mel-hiw-tab-group'), btn.getAttribute('data-mel-hiw-tab'));
    });
  });

  // --- Detail mobile accordion (single panel open at a time, per guide) ---
  var accTriggers = Array.prototype.slice.call(document.querySelectorAll('[data-mel-hiw-acc-trigger]'));

  function setOpenAccordion(group, openKey) {
    accTriggers.forEach(function (trigger) {
      if (trigger.getAttribute('data-mel-hiw-tab-group') !== group) return;
      var key = trigger.getAttribute('data-mel-hiw-acc-trigger');
      var open = key === openKey;
      var label = trigger.querySelector('[data-mel-hiw-acc-label]');
      var iconWrap = trigger.querySelector('[data-mel-hiw-acc-icon]');
      var panel = document.querySelector('[data-mel-hiw-acc-panel="' + key + '"][data-mel-hiw-tab-group="' + group + '"]');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) {
        label.classList.toggle('text-[#0268A0]', open);
        label.classList.toggle('text-[#161F2B]', !open);
      }
      if (iconWrap) iconWrap.innerHTML = open ? MINUS_ICON : PLUS_ICON;
      if (panel) {
        panel.classList.toggle('max-h-0', !open);
        panel.classList.toggle('opacity-0', !open);
        panel.classList.toggle('max-h-[800px]', open);
        panel.classList.toggle('opacity-100', open);
      }
    });
  }

  accTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var group = trigger.getAttribute('data-mel-hiw-tab-group');
      var key = trigger.getAttribute('data-mel-hiw-acc-trigger');
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      setOpenAccordion(group, isOpen ? null : key);
    });
  });

  // --- Compare button -> smooth-scroll to the comparison table ---
  Array.prototype.slice.call(document.querySelectorAll('[data-mel-hiw-compare]')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById('comparison');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // --- Comparison table scroll arrows + mobile position indicator ---
  var compareScroll = document.querySelector('[data-mel-hiw-compare-scroll]');
  var comparePrev = document.querySelector('[data-mel-hiw-compare-prev]');
  var compareNext = document.querySelector('[data-mel-hiw-compare-next]');
  var compareThumb = document.querySelector('[data-mel-hiw-compare-thumb]');

  function updateCompareControls() {
    if (!compareScroll) return;
    var maxScroll = compareScroll.scrollWidth - compareScroll.clientWidth;
    var scrollable = maxScroll > 4;
    [comparePrev, compareNext].forEach(function (btn) {
      if (!btn) return;
      btn.classList.toggle('pointer-events-none', !scrollable);
      btn.classList.toggle('opacity-0', !scrollable);
    });
    if (comparePrev) comparePrev.disabled = compareScroll.scrollLeft <= 4;
    if (compareNext) compareNext.disabled = compareScroll.scrollLeft >= maxScroll - 4;
    if (compareThumb && maxScroll > 0) {
      var ratio = compareScroll.scrollLeft / maxScroll;
      compareThumb.style.left = (ratio * (100 - 33.333)) + '%';
    } else if (compareThumb) {
      compareThumb.style.left = '0%';
    }
  }

  if (compareScroll) {
    compareScroll.addEventListener('scroll', updateCompareControls);
    window.addEventListener('resize', updateCompareControls);
    updateCompareControls();
  }
  if (comparePrev) {
    comparePrev.addEventListener('click', function () {
      if (compareScroll) compareScroll.scrollBy({ left: -280, behavior: 'smooth' });
    });
  }
  if (compareNext) {
    compareNext.addEventListener('click', function () {
      if (compareScroll) compareScroll.scrollBy({ left: 280, behavior: 'smooth' });
    });
  }

  // --- Reviews carousel: prev/next arrows + dot pagination ---
  var reviewsTrack = document.querySelector('[data-mel-hiw-reviews-track]');
  var reviewCards = reviewsTrack ? Array.prototype.slice.call(reviewsTrack.querySelectorAll('[data-mel-hiw-review-card]')) : [];
  var reviewDots = Array.prototype.slice.call(document.querySelectorAll('[data-mel-hiw-review-dot]'));
  var reviewPrev = document.querySelector('[data-mel-hiw-review-prev]');
  var reviewNext = document.querySelector('[data-mel-hiw-review-next]');

  function currentReviewIndex() {
    if (!reviewsTrack || !reviewCards.length) return 0;
    var scrollLeft = reviewsTrack.scrollLeft;
    var closest = 0;
    var closestDist = Infinity;
    reviewCards.forEach(function (card, i) {
      var dist = Math.abs(card.offsetLeft - scrollLeft);
      if (dist < closestDist) {
        closestDist = dist;
        closest = i;
      }
    });
    return closest;
  }

  function setActiveDot(index) {
    reviewDots.forEach(function (dot) {
      var active = dot.getAttribute('data-mel-hiw-review-dot') === String(index);
      dot.classList.toggle('bg-[#0268A0]', active);
      dot.classList.toggle('bg-[#0268A0]/30', !active);
      dot.classList.toggle('hover:bg-[#0268A0]/50', !active);
    });
  }

  function scrollToReview(index) {
    if (!reviewsTrack || !reviewCards[index]) return;
    reviewsTrack.scrollTo({ left: reviewCards[index].offsetLeft, behavior: 'smooth' });
    setActiveDot(index);
  }

  reviewDots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      scrollToReview(parseInt(dot.getAttribute('data-mel-hiw-review-dot'), 10));
    });
  });
  if (reviewPrev) {
    reviewPrev.addEventListener('click', function () {
      scrollToReview(Math.max(0, currentReviewIndex() - 1));
    });
  }
  if (reviewNext) {
    reviewNext.addEventListener('click', function () {
      scrollToReview(Math.min(reviewCards.length - 1, currentReviewIndex() + 1));
    });
  }
  if (reviewsTrack) {
    var reviewScrollTimer;
    reviewsTrack.addEventListener('scroll', function () {
      clearTimeout(reviewScrollTimer);
      reviewScrollTimer = setTimeout(function () {
        setActiveDot(currentReviewIndex());
      }, 100);
    });
  }
})();
